export default __webpack_public_path__ + "static/mission-rabies-logo-8e776cb9199d0b245b5fdb882eaf27a2.svg";